import { render, staticRenderFns } from "./ItemGroupForm.vue?vue&type=template&id=2b7a0be2&scoped=true&"
import script from "./ItemGroupForm.vue?vue&type=script&lang=js&"
export * from "./ItemGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./ItemGroupForm.vue?vue&type=style&index=0&id=2b7a0be2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a0be2",
  null
  
)

export default component.exports